import {permissions, PermissionsKeys, PermissionsRecordType} from '../permissions';

export const getRequestedPermissionsFromKeys = (permissionKeys: PermissionsKeys[]) =>
  permissionKeys.map((key: string) => ({...(permissions as PermissionsRecordType)[key], key}));
